import React, { useState } from "react";
import { Button, Card, Form, Input, Select, Alert } from "antd";
import { sendMail } from "../utils/mail";
import StorageService from "../utils/storage";

const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(",")[1]; // Remove the prefix
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });
};

const convertAntdFileToNativeFile = (file) => {
    return file.originFileObj;
};

export const CareerForm = () => {
    const [form] = Form.useForm();
    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]); // Get the uploaded file
    };

    const onSubmit = async (values) => {
        try {
            setShow(false);

            const organisation = StorageService.getItem("organisation");
            const to = organisation?.email || "afzal+pb@busable.app";

            const attachmentPromises = [file].map(async (file) => {
                if (file.originFileObj) {
                    const nativeFile = convertAntdFileToNativeFile(file);
                    const base64Content = await convertToBase64(nativeFile);
                    return {
                        BinaryContent: base64Content,
                        Name: nativeFile.name,
                        ContentType: nativeFile.type,
                        Size: nativeFile.size,
                    };
                }

                if (file instanceof Blob || file instanceof File) {
                    const base64Content = await convertToBase64(file);
                    return {
                        BinaryContent: base64Content,
                        Name: file.name,
                        ContentType: file.type,
                        Size: file.size,
                    };
                }

                throw new Error("Unsupported attachment format");
            });

            const attachments = await Promise.all(attachmentPromises);

            await sendMail({
                to,
                from: "Busable <hello@busable.com.au>",
                subject: `New Career Submit - ${values.email}`,
                merge: {
                    ...values,
                    email_id: values.email,
                },
                template: "Careers",
                attachments,
            });
            setShow(true);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Card bordered={false} className="CardItem" style={{ paddingTop: 20 }}>
            {show === true && (
                <Alert
                    closable
                    onClose={() => setShow(false)}
                    message="Your Career Request has been sent successfully."
                    type="success"
                    style={{ marginBottom: "30px" }}
                />
            )}
            <Form
                form={form}
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 24,
                }}
                layout="horizontal"
                size="large"
                style={{
                    maxWidth: 600,
                }}
                onFinish={onSubmit}
            >
                <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please input your name!" }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Email" name="email" rules={[{ required: true, message: "Please input your email!" }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Phone" name="phone" rules={[{ required: true, message: "Please input your phone number!" }]}>
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Qualification"
                    name="qualification"
                    rules={[{ required: true, message: "Please input your qualification!" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Attach Resume" name="resume" rules={[{ required: true, message: "Please attach your resume!" }]}>
                    <Input type="file" onChange={handleFileChange} multiple={false} />
                </Form.Item>
                <Form.Item label="Message" name="message" rules={[{ required: true, message: "Please input your message!" }]}>
                    <Input.TextArea />
                </Form.Item>
                <Form.Item wrapperCol={{ md: { offset: 8, span: 16 } }}>
                    <Button htmlType="submit" size="small" className="btn-secondary">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};
